<script setup>
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// 异步加载百度统计代码
const initBaiduAnalytics = () => {
  return new Promise((resolve) => {
    if (window._hmt) {
      resolve()
      return
    }
    
    window._hmt = []
    const script = document.createElement('script')
    script.src = 'https://hm.baidu.com/hm.js?de0926b96bc2a81fdd0ac175a2eb7973'
    script.async = true
    script.onload = resolve
    document.head.appendChild(script)
  })
}

// 延迟执行页面统计
const trackPageview = (path) => {
  if (window._hmt) {
    // 使用 requestAnimationFrame 确保在页面渲染完成后执行
    requestAnimationFrame(() => {
      window._hmt.push(['_trackPageview', path])
    })
  }
}

// 监听路由变化
watch(() => route.path, (newPath) => {
  trackPageview(newPath)
})

onMounted(async () => {
  console.log('App组件已挂载')
  // 异步初始化百度统计
  await initBaiduAnalytics()
  // 记录初始页面访问
  trackPageview(route.path)
})
</script>

<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f8fa;
}

#app {
  height: 100%;
}

.app-container {
  height: 100%;
}
</style>
